module.exports = __webpack_public_path__ + "img/ahead.3f63542b.png";